import { toast } from 'react-toastify';

export const showToast = (message, type) => {
    // console.log(`Toast message: "${message}", type: "${type}"`);

    if (!message || typeof message !== 'string' || !type || typeof type !== 'string') {
        console.warn('Toast not shown. Invalid message or type:', { message, type });
        return;
    }

    const options = {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
    };

    switch (type) {
        case 'success':
            toast.success(message, options);
            break;
        case 'error':
            toast.error(message, options);
            break;
        case 'info':
            toast.info(message, options);
            break;
        case 'warning':
            toast.warning(message, options);
            break;
        default:
            console.warn('Unknown toast type:', type);
            break;
    }
};




// if you need to show in queue one by one  use below code 
// import { toast } from 'react-toastify';

// let toastQueue = [];
// let isToastActive = false;

// const defaultOptions = {
//     position: 'top-center',
//     autoClose: 5000,
//     hideProgressBar: true,
//     closeOnClick: true,
//     pauseOnHover: true,
//     draggable: true,
//     progress: undefined,
//     theme: 'colored',
// };

// const processQueue = () => {
//     if (isToastActive || toastQueue.length === 0) return;

//     const { message, type } = toastQueue.shift();
//     isToastActive = true;

//     const onClose = () => {
//         isToastActive = false;
//         setTimeout(processQueue, 300); // Delay between toasts
//     };

//     const options = { ...defaultOptions, onClose };

//     switch (type) {
//         case 'success':
//             toast.success(message, options);
//             break;
//         case 'error':
//             toast.error(message, options);
//             break;
//         case 'info':
//             toast.info(message, options);
//             break;
//         case 'warning':
//             toast.warning(message, options);
//             break;
//         default:
//             console.warn('Unknown toast type:', type);
//             isToastActive = false;
//             break;
//     }
// };

// // ✅ Use this in place of direct toast.*
// export const showToast = (message, type) => {
//     console.log(`Toast message: "${message}", type: "${type}"`);

//     if (!message || typeof message !== 'string' || !type || typeof type !== 'string') {
//         console.warn('Toast not shown. Invalid message or type:', { message, type });
//         return;
//     }

//     toastQueue.push({ message, type });
//     processQueue();
// };
